import { defineRouter } from '#q-app/wrappers'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import { useAuthStore } from 'stores/auth-store'
import routes from './routes'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter((/* { store, ssrContext } */) => {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  })

  Router.beforeEach((to) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicRouteNames = ['Login', 'ObserverScout']
    // Check if the route has a name, and cast it 'as string' to satisfy TypeScript
    const authRequired = !to.name || !publicRouteNames.includes(to.name as string)

    const { IsUserLoggedIn } = useAuthStore()
    if (authRequired && !IsUserLoggedIn) {
      return '/login'
    }
  })
  return Router
})
